export default __webpack_public_path__ + "static/media/img3.03baa827.jpg";